"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var classnames_1 = __importDefault(require("classnames"));
var Loader_1 = __importDefault(require("../../common/Loader"));
var Container_1 = __importDefault(require("../../common/Container"));
var BreadcrumbsModule_1 = __importDefault(require("../../common/BreadcrumbsModule"));
var Views_1 = __importDefault(require("./Views"));
var Bar_1 = __importDefault(require("./Bar"));
var Navigation_1 = __importDefault(require("./Navigation"));
var Advantages_1 = __importDefault(require("../../common/Advantages"));
var Description_1 = __importDefault(require("../../common/Description"));
var BeforeFooterText_1 = __importDefault(require("./BeforeFooterText"));
var Tags_1 = __importDefault(require("./Tags"));
var Author_1 = __importDefault(require("./Author"));
var SimilarProducts_1 = __importDefault(require("../../common/SimilarProducts"));
var SiblingProducts_1 = __importDefault(require("./SiblingProducts"));
var SocialLinks_1 = __importDefault(require("../../common/SocialLinks"));
var CartInfo_1 = __importDefault(require("./CartInfo"));
var BannedInfo_1 = __importDefault(require("./BannedInfo"));
var Neighboring_1 = __importDefault(require("./Neighboring"));
var breadcrumbs_1 = require("../ducks/breadcrumbs");
var product_1 = require("../ducks/product");
var itemSeo_1 = require("../ducks/itemSeo");
var location_data_1 = require("../ducks/location-data");
var reviews_1 = require("../ducks/reviews");
var url_1 = require("../ducks/url");
var product_descriptions_1 = __importDefault(require("../../../mocks/product-descriptions"));
var cart_info_1 = require("../ducks/cart-info");
var licensee_store_1 = require("../ducks/licensee-store");
var root_module_scss_1 = __importDefault(require("./root.module.scss"));
var onPlatform_1 = require("../ducks/onPlatform");
var utils_1 = require("../utils");
var Root = function () {
    var _a;
    var url = (0, react_redux_1.useSelector)(url_1.urlSelector);
    var breadcrumbs = (0, react_redux_1.useSelector)(breadcrumbs_1.breadcrumbsSelector);
    var product = (0, react_redux_1.useSelector)(product_1.productSelector);
    var singular = product.singular, permalink = product.permalink, name = product.name, condition = product.condition, itemTitle = product.title, itemDescription = product.description, views = product.views, banned = product.banned, clones = product.clones, neighboring = product.neighboring;
    var seo = (0, react_redux_1.useSelector)(itemSeo_1.seoSelector);
    var locationData = (0, react_redux_1.useSelector)(location_data_1.locationDataSelector);
    var reviews = (0, react_redux_1.useSelector)(reviews_1.reviewsSelector);
    var cartInfo = (0, react_redux_1.useSelector)(cart_info_1.cartInfoSelector);
    var licenseeStore = (0, react_redux_1.useSelector)(licensee_store_1.licenseeStoreSelector);
    var onPlatform = (0, react_redux_1.useSelector)(onPlatform_1.onPlatformSelector);
    var ga4 = (0, react_redux_1.useSelector)(function (state) { return state.ga4; });
    var description = product_descriptions_1.default[singular];
    (0, react_1.useEffect)(function () {
        var mainBannersOnMobile = document.querySelector('.main-teaser-container__mobile');
        if (!mainBannersOnMobile)
            return;
        mainBannersOnMobile.style.display = 'none';
        return function () {
            mainBannersOnMobile.style.display = '';
        };
    }, []);
    (0, react_1.useEffect)(function () {
        if (ga4 && ga4.itemId) {
            (0, utils_1.productGA4Event)('view_item', ga4);
        }
    }, [ga4]);
    return product.id ? (react_1.default.createElement("div", { className: (0, classnames_1.default)(root_module_scss_1.default.root, (_a = {},
            _a[root_module_scss_1.default.banned] = banned,
            _a[root_module_scss_1.default.rootVtb] = onPlatform === 'vtb',
            _a)), itemScope: true, itemType: "http://schema.org/Product" },
        onPlatform !== 'vtb' && (react_1.default.createElement("div", { className: root_module_scss_1.default.header },
            react_1.default.createElement(Container_1.default, null,
                react_1.default.createElement(BreadcrumbsModule_1.default, { items: breadcrumbs })),
            react_1.default.createElement("div", { className: root_module_scss_1.default.search }))),
        cartInfo.path && (react_1.default.createElement("div", { className: root_module_scss_1.default.flash },
            react_1.default.createElement(Container_1.default, null,
                react_1.default.createElement(CartInfo_1.default, null)))),
        banned && (react_1.default.createElement("div", { className: root_module_scss_1.default.flash },
            react_1.default.createElement(Container_1.default, null,
                react_1.default.createElement(BannedInfo_1.default, null)))),
        react_1.default.createElement("div", { className: root_module_scss_1.default.content },
            react_1.default.createElement(Container_1.default, null,
                react_1.default.createElement("div", { className: root_module_scss_1.default.navigation },
                    react_1.default.createElement(Navigation_1.default, null)),
                react_1.default.createElement("div", { className: root_module_scss_1.default.container },
                    react_1.default.createElement(Views_1.default, null),
                    react_1.default.createElement("div", { className: root_module_scss_1.default.bar },
                        react_1.default.createElement(Bar_1.default, null)))),
            !licenseeStore && onPlatform !== 'vtb' && (react_1.default.createElement("div", { className: root_module_scss_1.default.author },
                react_1.default.createElement(Container_1.default, null,
                    react_1.default.createElement(Author_1.default, null)))),
            !licenseeStore && (react_1.default.createElement("div", { className: root_module_scss_1.default.tags },
                react_1.default.createElement(Container_1.default, null,
                    react_1.default.createElement(Tags_1.default, null))))),
        !licenseeStore && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: root_module_scss_1.default.advantages },
                react_1.default.createElement(Container_1.default, null,
                    react_1.default.createElement(Advantages_1.default, { productName: singular, condition: condition }))),
            description && (react_1.default.createElement("div", { className: root_module_scss_1.default.description },
                react_1.default.createElement(Container_1.default, null,
                    react_1.default.createElement(Description_1.default, { product: product, url: url, seo: seo, locationData: locationData, reviews: reviews, permalink: permalink, clones: clones, onPlatform: onPlatform })))),
            react_1.default.createElement("div", { className: root_module_scss_1.default.socialLinks },
                react_1.default.createElement(Container_1.default, null,
                    react_1.default.createElement(SocialLinks_1.default, { url: url, title: "".concat(name, " ").concat(itemTitle), description: itemDescription, media: views.large ? views.large[0] : '/' }))),
            onPlatform !== 'vtb' && (react_1.default.createElement(Container_1.default, null,
                react_1.default.createElement(BeforeFooterText_1.default, { content: seo.beforeFooterText }),
                react_1.default.createElement(SiblingProducts_1.default, null),
                react_1.default.createElement(SimilarProducts_1.default, null),
                react_1.default.createElement(Neighboring_1.default, { previous: neighboring.previous, next: neighboring.next }))))))) : (react_1.default.createElement("div", { className: root_module_scss_1.default.loaderWrapper },
        react_1.default.createElement(Loader_1.default, null)));
};
exports.default = Root;
